import React from 'react'

// styles
import Container from "./styles/Container";

// includes
import {
	Footer,
	Body
} from "./includes";

export default function ProductDetail(props) {
	// props
	const {
		availableCombinations,

		allowedVariantsValues,
		setAllowedVariantsValues,

		currentRoute,

		productsDetailsLoading,
		productDetails,
		productDetailsCombinationWise,
		combinationNotAvailable,

		variantMainFields,
		productCombinations,
		productCombinationsImages,

		selectedOptionsByUser,
		setSelectedOptionsByUser,

		buttonLoading,
		handleAddToCartButtonClick,

		generateValues,

		selectedValue,
		setSelectedValue,

		productQuantity,
		setProductQuantity
	} = props

	return (
		<Container className="container pt-4">
			<Body
				availableCombinations={availableCombinations}

				allowedVariantsValues={allowedVariantsValues}
				setAllowedVariantsValues={setAllowedVariantsValues}

				currentRoute={currentRoute}
				productsDetailsLoading={productsDetailsLoading}
				productDetails={productDetails}
				productDetailsCombinationWise={productDetailsCombinationWise}
				combinationNotAvailable={combinationNotAvailable}

				variantMainFields={variantMainFields}
				productCombinations={productCombinations}
				productCombinationsImages={productCombinationsImages}

				selectedOptionsByUser={selectedOptionsByUser}
				setSelectedOptionsByUser={setSelectedOptionsByUser}

				buttonLoading={buttonLoading}
				handleAddToCartButtonClick={(ev, selectedProduct) => handleAddToCartButtonClick(ev, selectedProduct)}

				generateValues={generateValues}

				selectedValue={selectedValue}
				setSelectedValue={setSelectedValue}

				productQuantity={productQuantity}
				setProductQuantity={setProductQuantity}
			/>
			{/* <Footer /> */}
		</Container>
	)
}
